// extracted by mini-css-extract-plugin
export default {"container":"hom_2wl_","blocks":"hom_blo_2bvW2"};